module.exports = __webpack_public_path__ + "img/Vannak.4583240f.png";